import moment from 'moment-timezone';

export const getHoursRangeText = (
  date: string | Date,
  duration: number = 0,
  locale?: string,
  timezone?: string,
) => {
  const settings = Intl.DateTimeFormat(locale, {
    timeZone: timezone,
    hour: 'numeric',
    minute: 'numeric',
  });
  const start = settings.format(moment(date).toDate());
  const end = settings.format(moment(date).add(duration, 'minutes').toDate());

  return `${start} - ${end}`;
};

export const getDayText = (
  date: string | Date,
  locale: string,
  timezone?: string,
) => {
  return Intl.DateTimeFormat(locale, {
    timeZone: timezone,
    weekday: 'long',
    month: 'long',
    day: 'numeric',
  }).format(moment(date).toDate());
};
